import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutQualifierCodeQuickInfo extends Layout {
    panelQualifierCodeQuickInfo: Panel;
    sourceEdiStandardCode: DataSource;
    sourceQualifierCode: DataSource;
    textboxDescription: Textbox;
    textboxDescriptionSC: Textbox;
    textboxStandardCode: Textbox;
    textboxStandardCodeSC: Textbox;
}
